const capitalizeFirstLetterInAllWords = (text: string) => {
  return text
    .trim() // Remove leading/trailing spaces
    .split(/\s+/) // Split by any number of spaces
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export default capitalizeFirstLetterInAllWords;
